import React, { useEffect, useState } from "react";
import PageComponentHeader from "../PageComponentHeader";
import Loader from "../Loader/Loader";
import DataTable from "../UIKit/CollapsibleTable";
import { filesTableHeader } from "../../constants/componentConstants";
import { useGetFileStatusesQuery } from "../../RTKQuery/FileService/fileApi";
import ActionButtons from "./ActionButton";
import {
  subscribeToFileStatus,
  unsubscribeFromFileStatus,
} from "../../Services/websockets";
import CircularWithValueLabel from "../UIKit/CircularProgressWithLabel";
import { useSelector, useDispatch } from "react-redux";
import { Box } from "@mui/material";
import { Chip } from "@mui/material";

export default function FilesList() {
  const [rows, setRows] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [sorting, setSorting] = useState([]);
  const [isLoader, setLoader] = useState(false);
  const [progress, setProgress] = useState(0);

  // Fetch data from the API
  const { data, isLoading, isError, refetch } = useGetFileStatusesQuery(
    {
      page: currentPage,
      rows,
    },
    { refetchOnMountOrArgChange: true }
  );

  const files = useSelector((state) => state.file.files);
  const dispatch = useDispatch();

  // Synchronize tableData with API response
  // useEffect(() => {
  //   if (data) {
  //     const updatedData = data.map((file) => ({
  //       ...file,
  //       progress:
  //         file.totalCampaigns && file.processedCampaigns
  //           ? Math.round((file.processedCampaigns / file.totalCampaigns) * 100)
  //           : 0,
  //     }));
  //     setTableData(updatedData);
  //   }
  // }, [data]);
  // Update the tableData based on the global files state

  // Synchronize tableData with API response or Redux store
  useEffect(() => {
    if (data) {
      // const updatedData = data.map((file) => ({
      //   ...file,
      //   progress:
      //     file.totalCampaigns && file.processedCampaigns
      //       ? Math.round((file.processedCampaigns / file.totalCampaigns) * 100)
      //       : 0,
      //   status: file.status || "pending", // Ensure status is available
      // }));
      setTableData(data);
    }
  }, [data]);
  useEffect(() => {
    if (files && files.length > 0) {
      setTableData((prevData) =>
        prevData.map((row) => {
          const matchingFile = files.find((file) => file.id === row.id);
          if (matchingFile) {
            return {
              ...row,
              progress: matchingFile.progress,
              status: matchingFile.status,
            };
          }
          return row;
        })
      );
    }
  }, [files]);

  // Listen for WebSocket updates
  // useEffect(() => {
  //   subscribeToFileStatus(({ event, data }) => {
  //     console.log(
  //       `Received WebSocket Update: event=${event}, data=${JSON.stringify(
  //         data
  //       )}`
  //     );
  //     setTableData((prev) =>
  //       prev.map((row) => {
  //         if (row.id === data.id) {
  //           const { totalCampaigns, processedCampaigns, status } = data;
  //           return {
  //             ...row,
  //             status,
  //             progress: totalCampaigns
  //               ? Math.round((processedCampaigns / totalCampaigns) * 100)
  //               : 0,
  //           };
  //         }
  //         return row;
  //       })
  //     );
  //   });

  //   return () => {
  //     unsubscribeFromFileStatus();
  //   };
  // }, []);

  const handlePaginationChange = ({ pageIndex, pageSize }) => {
    setLoader(true);
    setCurrentPage(pageIndex);
    setRows(pageSize);
  };

  if (isLoading || isLoader) {
    return (
      <div className="noData">
        <Loader />
      </div>
    );
  }

  if (isError) {
    return (
      <h3 className="noData">Error loading data. Please try again later.</h3>
    );
  }

  const FilesColumns = [
    {
      accessorKey: "originalName",
      header: "File Name",
      enableSorting: false,
      size: 200,
    },
    {
      accessorKey: "createdAt",
      header: "Uploaded on",
      enableSorting: false,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "status",
      header: "Status",
      enableSorting: false,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      Cell: ({ row }) => {
        const { status } = row.original;
        const statusMap = {
          error: { label: "Error", color: "error" },
          completed: { label: "Completed", color: "success" },
          processing: { label: "Processing", color: "warning" },
        };
        const chipProps = statusMap[status] || {
          label: status,
          color: "default",
        };
        return (
          <Chip label={chipProps.label} color={chipProps.color} size="small" />
        );
      },
    },
    {
      accessorKey: "progress",
      header: "Progress",
      enableSorting: false,
      Cell: ({ row }) => {
        const progress = row.original.progress || 0;
        const status = row.original.status;
        return (
          <div>
            {status !== "completed" ? (
              <CircularWithValueLabel value={progress} />
            ) : (
              // progress
              "Completed"
            )}
          </div>
        );
      },
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "addedUserCount",
      header: "Added New Users",
      Cell: ({ cell }) => (
        <Box
          sx={{
            bgcolor: "#e6f4ea",
            px: 1.5,
            py: 0.5,
            borderRadius: 1,
            color: "#388e3c",
            fontWeight: 500,
            textAlign: "center",
          }}
        >
          {cell.getValue() || 0}
        </Box>
      ),
      enableSorting: false,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "updatedserCount",
      header: "Updated Existing Users",
      Cell: ({ cell }) => (
        <Box
          sx={{
            bgcolor: "#fff4e5",
            px: 1.5,
            py: 0.5,
            borderRadius: 1,
            color: "#f57c00",
            fontWeight: 500,
            textAlign: "center",
          }}
        >
          {cell.getValue() || 0}
        </Box>
      ),
      enableSorting: false,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
    {
      accessorKey: "invalidUserCount",
      header: "Invalid Users Blocked",
      enableSorting: false,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      Cell: ({ cell }) => (
        <Box
          sx={{
            bgcolor: "#ffebee",
            px: 1.5,
            py: 0.5,
            borderRadius: 1,
            color: "#d32f2f",
            fontWeight: 500,
            textAlign: "center",
          }}
        >
          {cell.getValue() || 0}
        </Box>
      ),
    },
    {
      accessorKey: "_",
      header: "Actions",
      enableSorting: false,
      Cell: ({ row }) => (
        <div>
          <ActionButtons data={row} />
        </div>
      ),
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
  ];

  return (
    <div>
      <PageComponentHeader pageTitle="My Files" />
      {tableData && tableData.length > 0 ? (
        <div style={{ marginTop: "1rem" }}>
          <DataTable
            columns={FilesColumns}
            data={tableData}
            selectable={false}
            setSorting={setSorting}
            totalData={data?.length || 0}
            sorting={sorting}
            pagination={{ pageIndex: currentPage, pageSize: rows }}
            setPagination={handlePaginationChange}
            density={"comfortable"}
            enableCollapsibleRow={false}
            setLoader={setLoader}
          />
        </div>
      ) : (
        <h3 className="noData">No Record Found</h3>
      )}
    </div>
  );
}
